import { render, staticRenderFns } from "./RecibosRecebimento.vue?vue&type=template&id=3b632a90"
import script from "./RecibosRecebimento.vue?vue&type=script&lang=js"
export * from "./RecibosRecebimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports